import { Col, Row } from 'antd'
import React from 'react'

const MonthlyTabContent1 = ({ RadioGroup, RadioButton, selectedAmount }) => {
	return (
		<>
			<RadioGroup
				buttonStyle='solid'
				size='large'
				style={{
					flexDirection: 'column',
					width: '100%'
				}}
				defaultValue='300'
			>
				<Row>
					<Col xl={8} xs={12}>
						<RadioButton
							value='300'
							onChange={() => {
								selectedAmount('300')
							}}
							style={{
								width: '100%',
								height: 60,
								paddingTop: 5,
								paddingLeft: 15
							}}
						>
							300 ৳
						</RadioButton>
					</Col>
					<Col xl={8} xs={12}>
						<RadioButton
							value='500'
							onChange={() => {
								selectedAmount('500')
							}}
							style={{
								width: '100%',
								height: 60,
								paddingTop: 5,
								paddingLeft: 15
							}}
						>
							500 ৳
						</RadioButton>
					</Col>
					<Col xl={8} xs={12}>
						<RadioButton
							value='1000'
							onChange={() => {
								selectedAmount('1000')
							}}
							style={{
								width: '100%',
								height: 60,
								paddingTop: 5,
								paddingLeft: 15
							}}
						>
							1000 ৳
						</RadioButton>
					</Col>
					<Col xl={8} xs={12}>
						<RadioButton
							value='2000'
							onChange={() => {
								selectedAmount('2000')
							}}
							style={{
								width: '100%',
								height: 60,
								paddingTop: 5,
								paddingLeft: 15
							}}
						>
							2000 ৳
						</RadioButton>
					</Col>
					<Col xl={8} xs={12}>
						<RadioButton
							value='5000'
							onChange={() => {
								selectedAmount('5000')
							}}
							style={{
								width: '100%',
								height: 60,
								paddingTop: 5,
								paddingLeft: 15
							}}
						>
							5000 ৳
						</RadioButton>
					</Col>
					<Col xl={8} xs={12}>
						<RadioButton
							value='0'
							onChange={() => {
								selectedAmount('0')
							}}
							style={{
								width: '100%',
								height: 60,
								paddingTop: 5,
								paddingLeft: 15
							}}
						>
							Other
						</RadioButton>
					</Col>
				</Row>
			</RadioGroup>
		</>
	)
}

export default MonthlyTabContent1
